import React from "react";
import { T } from "services/lang/LanguageService";
import { DatasetStringValueMapperDTO } from "../../../charts/interfaces";

const MapperMappings = ({
  selectedMapper,
}: {
  selectedMapper: DatasetStringValueMapperDTO;
}) => {
  return (
    <div>
      {Object.keys(selectedMapper.mappings).length === 0 ? (
        <h3>{T("word.no-mappings")}</h3>
      ) : (
        <ul>
          {Object.entries(selectedMapper.mappings).map(([key, value]) => (
            <li key={key}>
              {key}: {value}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MapperMappings;
